import axios from "axios";
import IUploadFileRepoEntitiesType from "../Types/UploadFileRepoEntitiesType";
import IUploadFileRepoURLType from "../Types/UploadFileRepoURLType";
import IUploadFileType from "../Types/UploadFileType";
import AccessTokenService from "./AccessTokenService";

const baseUrl: string = 'https://dev.azure.com/assistpoint/Data%20Model%20Tool/_apis/git/repositories/DataModelViewer-Files';

const getAccessToken = async () => {
    let token = '';

    await AccessTokenService.requestAccessToken()
        .then((response) => {
            if(response.status === 200) {
                token = response.data.access_token;
            }
        })

    return token;
}

const getUploadFileRepoURL = async () => {
    
    const localToken = await getAccessToken();
    const token = `Bearer ${localToken}`;

    return axios.get<IUploadFileRepoURLType>(`${baseUrl}/items?path=data/&api-version=7.0`, {
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': token
        }
    });
};

const getStandardsFileRepoURL = async () => {
    const localToken = await getAccessToken();
    const token = `Bearer ${localToken}`;

    return axios.get<IUploadFileRepoURLType>(`${baseUrl}/items?path=standard/&api-version=7.0`, {
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': token
        }
    });
};

const getTemplateFileRepoURL = async () => {
    const localToken = await getAccessToken();
    const token = `Bearer ${localToken}`;

    return axios.get<IUploadFileRepoURLType>(`${baseUrl}/items?path=template/&api-version=7.0`, {
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': token
        }
    });
};

const getUploadFileRepoEntities = async (treeUrl: string) => {
    const localToken = await getAccessToken();
    const token = `Bearer ${localToken}`;

    return axios.get<IUploadFileRepoEntitiesType>(treeUrl, {
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': token
        }
    });
};

const getTemplateFileRepoEntities = async (treeUrl: string) => {
    const localToken = await getAccessToken();
    const token = `Bearer ${localToken}`;

    return axios.get<IUploadFileRepoEntitiesType>(treeUrl, {
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': token
        }
    });
};

const postUploadFile = async (data: IUploadFileType) => {
    const localToken = await getAccessToken();
    const token = `Bearer ${localToken}`;

    return axios.post(`${baseUrl}/pushes?api-version=7.0`, JSON.stringify(data), {
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': token
        }
    });
};

const postTemplateFile = async (data: IUploadFileType) => {
    const localToken = await getAccessToken();
    const token = `Bearer ${localToken}`;

    return axios.post(`${baseUrl}/pushes?api-version=7.0`, JSON.stringify(data), {
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': token
        }
    });
};

const getFileContents = async (fileName: string) => {
    const localToken = await getAccessToken();
    const token = `Bearer ${localToken}`;

    return axios.get<string>(`${baseUrl}/items?path=data/${fileName}&download=true&api-version=7.0`, {
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/octet-stream; api-version=7.0',
            'Authorization': token
        }
    },
    );
};

const getStandardFileContents = async () => {
    
    const localToken = await getAccessToken();
    const token = `Bearer ${localToken}`;
    
    return axios.get<string>(`${baseUrl}/items?path=standard/standard_questions&download=true&api-version=7.0`, {
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/octet-stream; api-version=7.0',
            'Authorization': token
        }
    },
    );
};

const getTemplateFileContents = async (fileName: string) => {
    const localToken = await getAccessToken();
    const token = `Bearer ${localToken}`;

    return axios.get<string>(`${baseUrl}/items?path=template/${fileName}&download=true&api-version=7.0`, {
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/octet-stream; api-version=7.0',
            'Authorization': token
        }
    },
    );
};

const UploadFileService = {
    getUploadFileRepoURL,
    getUploadFileRepoEntities,
    postUploadFile,
    getFileContents,
    getStandardFileContents,
    getStandardsFileRepoURL,
    getTemplateFileRepoURL,
    getTemplateFileRepoEntities,
    postTemplateFile,
    getTemplateFileContents
};

export default UploadFileService;